import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import Sidebar from '@/components/layout/Sidebar';
import Header from '@/components/layout/Header';
import { useAppSelector } from '@/store/hooks';

// Content area loader - only shows in the content section, not full page
const ContentLoader = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 160px)',
      flexDirection: 'column',
      gap: 12,
    }}
  >
    <Spin size="large" />
  </div>
);

const { Content } = Layout;

const DashboardLayout = () => {
  const { sidebarCollapsed } = useAppSelector((state) => state.ui);
  const sidebarWidth = sidebarCollapsed ? 80 : 260;

  return (
    <Layout style={{ minHeight: '100vh', background: 'transparent' }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Main Layout */}
      <Layout
        style={{
          marginLeft: sidebarWidth,
          transition: 'margin-left 0.2s ease',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #e8f4fc 0%, #d4e8f5 50%, #c5ddef 100%)',
        }}
      >
        {/* Header Component */}
        <Header />

        {/* Main Content with Card Wrapper */}
        <Content style={{ padding: '24px', background: 'transparent' }}>
          <div
            style={{
              background: '#ffffff',
              borderRadius: 0,
              boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
              minHeight: 'calc(100vh - 120px)',
              overflow: 'hidden',
              padding: '24px',
            }}
          >
            <Suspense fallback={<ContentLoader />}>
              <Outlet />
            </Suspense>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
